import {Component, EventEmitter, Input, Output} from "@angular/core";
import {RiskFactor, ScreeningAlert} from "../../../../../../model/lookup-results.model";
import {LookupService} from "../../../../lookup.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "admin-lookup-factor-screening",
  templateUrl: "./screening.component.html",
  styleUrls: ["./screening.component.css"]
})
export class AdminLookupFactorScreeningComponent {

  @Input() factor: RiskFactor

  @Output() titleEmitter = new EventEmitter<string>();

  constructor(
    private singleService: LookupService,
  ) {
  }

  view(event: MouseEvent, alert: ScreeningAlert) {
    event.stopPropagation();
    this.singleService.viewEntry(this.titleEmitter, alert);
  }

  riskClass(alert: ScreeningAlert) {
    return this.singleService.riskClass(alert.risk!);
  }

  getNumberValue(value: number | undefined) {
    return value ?? 0.0;
  }

  bestScore(alert: ScreeningAlert): number | undefined {
    const scores = alert.hits
      .map(hit => hit.score)
      .filter((score): score is number => score !== undefined);

    return scores.length > 0 ? Math.max(...scores) : undefined;
  }

  worstScore(alert: ScreeningAlert): number | undefined {
    const scores = alert.hits
      .map(hit => hit.score)
      .filter((score): score is number => score !== undefined);

    return scores.length > 0 ? Math.min(...scores) : undefined;
  }

}
